// Cart Drawer Rose Edition
// Verwaltet Cart-Drawer-State und Cart-Daten via Shopify Ajax API.
// Hört auf 'cart:refresh' Events (von pdp-cart.js dispatched) und Header-Cart-Klick.

(function () {
  'use strict';

  const drawer = document.getElementById('CartDrawer');
  if (!drawer) return;

  const itemsContainer = document.getElementById('CartItems');
  const footer = document.getElementById('CartFooter');
  const progressEl = document.getElementById('CartProgress');
  const subtotalEl = drawer.querySelector('.cart-drawer-subtotal-value');
  const freeShippingThreshold = parseInt(drawer.dataset.freeShippingThreshold || '75', 10) * 100; // in cents
  const cartIconText = document.querySelector('.nav-cart span');

  function formatMoney(cents) {
    var cur=(window.Shopify&&Shopify.currency&&Shopify.currency.active)||'CHF';var loc=cur==='EUR'?'de-DE':'de-CH';try{return new Intl.NumberFormat(loc,{style:'currency',currency:cur}).format(cents/100);}catch(e){return cur+' '+(cents/100).toFixed(2);}
  }

  function escapeHtml(str) {
    if (!str) return '';
    return String(str)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }

  // ── Upsell-Konfiguration ──
  const UPSELL = {
    // Quell-Artikel (Single/Set), die ein Bundle-Upgrade bekommen → fixe Monate (null = Menge der Single)
    upgradeSources: {
      'wandelkraft': null, 'morgengold': null,
      'wandelkraft-3er-set': 3, 'morgengold-3er-set': 3,
      'wandelkraft-5er-set': 5, 'morgengold-5er-set': 5
    },
    // Monate → passendes Wandelkraft+Morgengold-Bundle (Handle). 5er greift, sobald 1/3/5 angelegt ist.
    bundleByMonths: {
      1: 'wandelkraft-morgengold-set-1-monatskur',
      2: 'wandelkraft-morgengold-set-2-monatskur',
      3: 'wandelkraft-morgengold-set-3-monatskur'
    },
    // Marketing-Namen 1:1 wie die Homepage-Bundle-Section (bundle-name-Divs)
    bundleNameByMonths: { 1: 'Probieren-Set', 2: 'Routine-Set', 3: 'Lebenswandel-Set' },
    // Einzelprodukt → passendes Set bei Menge 3/5 (bester Deal landet automatisch im Korb)
    setByQty: {
      'wandelkraft': { 3: 'wandelkraft-3er-set', 5: 'wandelkraft-5er-set' },
      'morgengold': { 3: 'morgengold-3er-set', 5: 'morgengold-5er-set' }
    },
    aboDiscount: 0.10
  };
  function isBundleHandle(h) { return (h || '').indexOf('wandelkraft-morgengold-set') === 0; }
  function lineMonths(it) {
    const v = UPSELL.upgradeSources[it.handle];
    return (v === null || v === undefined) ? it.quantity : v;
  }
  const _productCache = {};
  async function getProduct(handle) {
    if (!handle) return null;
    if (_productCache[handle]) return _productCache[handle];
    try {
      const r = await fetch('/products/' + handle + '.js', { headers: { Accept: 'application/json' } });
      if (!r.ok) return null;
      const p = await r.json();
      _productCache[handle] = p;
      return p;
    } catch (e) { return null; }
  }
  function pickPlanId(product, quantity) {
    const groups = (product && product.selling_plan_groups) || [];
    if (!groups.length) return null;
    const plans = groups[0].selling_plans || [];
    if (!plans.length) return null;
    const byName = (frag) => plans.find(p => (p.name || '').toLowerCase().indexOf(frag) !== -1);
    if (quantity >= 5) return (byName('alle 5') || byName('5 monate') || plans[0]).id;
    if (quantity >= 3) return (byName('alle 3') || byName('3 monate') || plans[0]).id;
    return (byName('jeden monat') || byName('monat') || plans[0]).id;
  }

  async function fetchCart() {
    const r = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
    return r.json();
  }

  function renderItem(item) {
    const img = item.image ? `<img class="cart-drawer-item-img" src="${item.image}" alt="${escapeHtml(item.product_title)}" loading="lazy">` : '<div class="cart-drawer-item-img"></div>';
    const variant = item.variant_title && item.variant_title !== 'Default Title'
      ? `<div class="variant">${escapeHtml(item.variant_title)}</div>` : '';
    const sellingPlan = item.selling_plan_allocation && item.selling_plan_allocation.selling_plan
      ? `<div class="selling-plan">Servicelieferung: ${escapeHtml(item.selling_plan_allocation.selling_plan.name)}</div>` : '';
    return `
      <div class="cart-drawer-item" data-key="${escapeHtml(item.key)}" data-handle="${escapeHtml(item.handle)}" data-abo="${item.selling_plan_allocation ? '1' : ''}">
        ${img}
        <div class="cart-drawer-item-info">
          <h3>${escapeHtml(item.product_title)}</h3>
          ${variant}
          ${sellingPlan}
          <div class="cart-drawer-qty">
            <button type="button" data-action="dec" aria-label="Menge reduzieren">−</button>
            <input type="text" value="${item.quantity}" readonly aria-label="Aktuelle Menge">
            <button type="button" data-action="inc" aria-label="Menge erhöhen">+</button>
          </div>
        </div>
        <div class="cart-drawer-item-side">
          <span class="cart-drawer-item-price">${formatMoney(item.final_line_price)}</span>
          <button class="cart-drawer-item-remove" type="button" data-action="remove">Entfernen</button>
        </div>
      </div>
    `;
  }

  function renderCart(cart) {
    if (!cart || cart.item_count === 0) {
      itemsContainer.innerHTML = `
        <div class="cart-drawer-empty">
          <p>Dein Warenkorb ist noch leer.</p>
          <a href="/" class="cart-drawer-empty-cta">Weiter shoppen</a>
        </div>
      `;
      footer.hidden = true;
      progressEl.hidden = true;
    } else {
      // Lieferhinweis (CH/LI, Markt-Reaktivierung 27.08.2026) — mit entfernen, wenn CH
      // wieder normal liefert. Gilt fuer die ganze Bestellung, darum EINMAL ueber den
      // Positionen statt an jeder Zeile (anders als der alte Wandelkraft-Engpass).
      const lhText = drawer.dataset.lieferhinweis;
      const lieferhinweis = lhText
        ? `<div class="pdp-stock-delay cart-lieferhinweis"><span class="pdp-stock-dot"></span>${escapeHtml(lhText)}</div>` : '';
      itemsContainer.innerHTML = lieferhinweis + cart.items.map(renderItem).join('');
      footer.hidden = false;
      subtotalEl.textContent = formatMoney(cart.total_price);
      if (freeShippingThreshold > 0) {
        progressEl.hidden = false;
        const remaining = freeShippingThreshold - cart.total_price;
        const text = progressEl.querySelector('.cart-drawer-progress-text');
        const fill = progressEl.querySelector('.cart-drawer-progress-fill');
        if (remaining <= 0) {
          text.textContent = '✓ Du erhältst gratis Versand';
          fill.style.width = '100%';
        } else {
          text.textContent = 'Nur noch ' + formatMoney(remaining) + ' bis gratis Versand';
          fill.style.width = Math.min(100, (cart.total_price / freeShippingThreshold) * 100) + '%';
        }
      }
    }
    renderUpsell(cart);
    if (cartIconText) {
      cartIconText.textContent = 'Warenkorb · ' + (cart ? cart.item_count : 0);
    }
  }

  async function renderUpsell(cart) {
    const el = document.getElementById('CartUpsell');
    if (!el) return;
    if (!cart || cart.item_count === 0) { el.hidden = true; el.innerHTML = ''; return; }
    let html = '';

    // ── Karte 1: Servicelieferung (Nicht-Abo-Artikel mit Plan) ──
    const aboLines = [];
    for (const it of cart.items) {
      if (it.selling_plan_allocation) continue;
      if (!Object.prototype.hasOwnProperty.call(UPSELL.upgradeSources, it.handle)) continue;
      const p = await getProduct(it.handle);
      if (p && p.selling_plan_groups && p.selling_plan_groups.length) aboLines.push(it);
    }
    if (aboLines.length) {
      const eligibleTotal = aboLines.reduce((s, it) => s + it.final_line_price, 0);
      const saving = Math.round(eligibleTotal * UPSELL.aboDiscount);
      const thumb = aboLines[0].image ? '<img src="' + aboLines[0].image + '" alt="" class="cart-upsell-thumb">' : '';
      // Intervall der Servicelieferung (jeden Monat / alle 3 / alle 5) — folgt der Set-Grösse im Korb, deckt sich mit pickPlanId
      const intervals = Array.from(new Set(aboLines.map(lineMonths)));
      const aboM = intervals.length === 1 ? intervals[0] : null;
      const intervalTxt = aboM >= 5 ? 'Alle 5 Monate · ' : aboM >= 3 ? 'Alle 3 Monate · ' : aboM ? 'Jeden Monat · ' : '';
      html += '<div class="cart-upsell-card">' + thumb +
        '<div class="cart-upsell-info"><div class="cart-upsell-title">Servicelieferung: 10% sparen</div>' +
        '<div class="cart-upsell-sub">' + intervalTxt + '<span class="cart-upsell-save">−' + formatMoney(saving) + '</span> · jederzeit kündbar</div></div>' +
        '<button class="cart-upsell-btn" data-action="upsell-abo" type="button">Aktivieren</button></div>';
    }

    // ── Karte 2: Bundle-Upgrade (Single/Set ohne Bundle → tauscht gegen Bundle) ──
    const hasBundle = cart.items.some(it => isBundleHandle(it.handle));
    const src = hasBundle ? null : cart.items.find(it => Object.prototype.hasOwnProperty.call(UPSELL.upgradeSources, it.handle));
    if (src) {
      const months = lineMonths(src);
      const bundleHandle = UPSELL.bundleByMonths[months];
      if (bundleHandle) {
        const b = await getProduct(bundleHandle);
        if (b && b.available && b.variants && b.variants.length) {
          const v = b.variants[0];
          const content = months + '× Morgengold + ' + months + '× Wandelkraft';
          const bundleName = UPSELL.bundleNameByMonths[months] || 'Bundle';
          const img = b.featured_image ? '<img src="' + b.featured_image + '" alt="" class="cart-upsell-thumb">' : '';
          const interval = 'alle ' + (months * 30) + ' Tage';
          // Beide Modi vorrechnen — Bundle einmalig vs. Servicelieferung
          const aboPlanId = pickPlanId(b, months);
          const bundleOnce = v.price;
          let bundleAbo = v.price;
          if (aboPlanId && v.selling_plan_allocations) {
            const al = v.selling_plan_allocations.find(a => a.selling_plan_id == aboPlanId);
            if (al) bundleAbo = al.price;
          }
          // Referenz je Modus: beide Set-Hälften zum jeweiligen Set-Preis (einmalig bzw. Abo)
          const sp = await getProduct(src.handle);
          const sv = (sp && sp.variants && sp.variants[0]) || null;
          const qty = src.quantity || 1;
          const srcOnceUnit = sv ? sv.price : Math.round(src.final_line_price / qty);
          let srcAboUnit = srcOnceUnit;
          if (sv) {
            const spPlan = pickPlanId(sp, months);
            if (spPlan && sv.selling_plan_allocations) {
              const a2 = sv.selling_plan_allocations.find(a => a.selling_plan_id == spPlan);
              if (a2) srcAboUnit = a2.price;
            }
          }
          const onceSave = (srcOnceUnit * qty * 2) > bundleOnce ? (srcOnceUnit * qty * 2) - bundleOnce : 0;
          const aboSave = (srcAboUnit * qty * 2) > bundleAbo ? (srcAboUnit * qty * 2) - bundleAbo : 0;
          const defaultMode = 'abo';
          html += '<div class="cart-upsell-card cart-upsell-bundle" data-default-mode="' + defaultMode + '"'
            + ' data-once-price="' + bundleOnce + '" data-once-save="' + onceSave + '"'
            + ' data-abo-price="' + bundleAbo + '" data-abo-save="' + aboSave + '"'
            + ' data-abo-plan="' + (aboPlanId || '') + '" data-interval="' + interval + '">'
            + '<div class="cart-upsell-bundle-top">' + img
            + '<div class="cart-upsell-info"><div class="cart-upsell-title">' + bundleName + '</div>'
            + '<div class="cart-upsell-sub">' + content + '</div></div></div>'
            + '<div class="cart-upsell-seg">'
            + '<button type="button" class="cart-upsell-seg-btn" data-mode="once">Einmalig</button>'
            + '<button type="button" class="cart-upsell-seg-btn" data-mode="abo">Servicelieferung</button>'
            + '</div>'
            + '<div class="cart-upsell-bundle-bottom">'
            + '<div><span class="cart-upsell-bprice"></span><span class="cart-upsell-save cart-upsell-bsave"></span></div>'
            + '<button class="cart-upsell-btn" data-action="upsell-bundle" data-variant="' + v.id + '" data-plan="" type="button">Wechseln</button>'
            + '</div></div>';
        }
      }
    }

    el.innerHTML = html;
    el.hidden = !html;
    Array.prototype.forEach.call(el.querySelectorAll('.cart-upsell-bundle'), function (card) {
      setBundleMode(card, card.dataset.defaultMode || 'abo');
    });
  }

  function setBundleMode(card, mode) {
    var isAbo = mode === 'abo';
    Array.prototype.forEach.call(card.querySelectorAll('.cart-upsell-seg-btn'), function (b) {
      b.classList.toggle('active', b.dataset.mode === mode);
    });
    var price = parseInt(isAbo ? card.dataset.aboPrice : card.dataset.oncePrice, 10) || 0;
    var save = parseInt(isAbo ? card.dataset.aboSave : card.dataset.onceSave, 10) || 0;
    var pe = card.querySelector('.cart-upsell-bprice');
    var se = card.querySelector('.cart-upsell-bsave');
    if (pe) pe.textContent = formatMoney(price) + (isAbo ? ' · ' + card.dataset.interval : '');
    if (se) se.textContent = save > 0 ? formatMoney(save) + ' sparen' : '';
    var btn = card.querySelector('.cart-upsell-btn[data-action="upsell-bundle"]');
    if (btn) btn.dataset.plan = isAbo ? (card.dataset.aboPlan || '') : '';
  }

  async function refreshCart() {
    try {
      const cart = await fetchCart();
      renderCart(cart);
      return cart;
    } catch (e) {
      console.warn('Cart refresh fehlgeschlagen', e);
    }
  }

  async function changeQuantity(key, qty) {
    const r = await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    });
    return r.json();
  }

  function openDrawer() {
    drawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }
  function closeDrawer() {
    drawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  // Event delegation in drawer
  drawer.addEventListener('click', async (e) => {
    if (e.target.closest('[data-cart-close]')) {
      closeDrawer();
      return;
    }
    const segBtn = e.target.closest('.cart-upsell-seg-btn');
    if (segBtn) {
      const card = segBtn.closest('.cart-upsell-bundle');
      if (card) setBundleMode(card, segBtn.dataset.mode);
      return;
    }
    const upsellBtn = e.target.closest('.cart-upsell-btn[data-action]');
    if (upsellBtn) {
      upsellBtn.disabled = true;
      const action = upsellBtn.dataset.action;
      try {
        if (action === 'upsell-bundle') {
          // Upgrade: alle Single/Set-Quellartikel raus, dann Bundle rein (kein Doppel)
          const current = await fetchCart();
          for (const it of current.items) {
            if (isBundleHandle(it.handle)) continue;
            if (!Object.prototype.hasOwnProperty.call(UPSELL.upgradeSources, it.handle)) continue;
            await fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: it.key, quantity: 0 }) });
          }
          const body = { id: parseInt(upsellBtn.dataset.variant, 10), quantity: 1 };
          if (upsellBtn.dataset.plan) body.selling_plan = parseInt(upsellBtn.dataset.plan, 10);
          await fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) });
        } else if (action === 'upsell-abo') {
          const current = await fetchCart();
          for (const it of current.items) {
            if (it.selling_plan_allocation) continue;
            if (!Object.prototype.hasOwnProperty.call(UPSELL.upgradeSources, it.handle)) continue;
            const p = await getProduct(it.handle);
            const planId = pickPlanId(p, lineMonths(it));
            if (!planId) continue;
            await fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: it.key, quantity: 0 }) });
            await fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: it.variant_id, quantity: it.quantity, selling_plan: planId }) });
          }
        }
        await refreshCart();
      } catch (err) {
        console.warn('Upsell-Aktion fehlgeschlagen', err);
        upsellBtn.disabled = false;
      }
      return;
    }
    const itemEl = e.target.closest('.cart-drawer-item');
    if (!itemEl) return;
    const button = e.target.closest('button[data-action]');
    if (!button) return;
    const key = itemEl.dataset.key;
    const handle = itemEl.dataset.handle;
    const isAbo = itemEl.dataset.abo === '1';
    const qtyInput = itemEl.querySelector('.cart-drawer-qty input');
    const currentQty = parseInt(qtyInput.value, 10) || 0;
    const action = button.dataset.action;
    let newQty = currentQty;
    if (action === 'inc') newQty = currentQty + 1;
    else if (action === 'dec') newQty = Math.max(0, currentQty - 1);
    else if (action === 'remove') newQty = 0;
    button.disabled = true;
    try {
      // Bester Deal: Einzelprodukt bei Menge 3/5 automatisch aufs passende Set umstellen
      const setMap = isAbo ? null : UPSELL.setByQty[handle];
      const setHandle = setMap && setMap[newQty];
      if (setHandle) {
        const sp = await getProduct(setHandle);
        const sv = sp && sp.variants && sp.variants[0];
        if (sv) {
          await changeQuantity(key, 0);
          await fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: sv.id, quantity: 1 }) });
          await refreshCart();
          return;
        }
      }
      const cart = await changeQuantity(key, newQty);
      renderCart(cart);
    } catch (err) {
      console.warn('Cart change fehlgeschlagen', err);
      button.disabled = false;
    }
  });

  // ESC schliesst
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && drawer.getAttribute('aria-hidden') === 'false') {
      closeDrawer();
    }
  });

  // Header cart icon → open drawer
  function bindHeaderCart() {
    const headerCart = document.querySelector('.nav-cart');
    if (!headerCart || headerCart.dataset.bound === '1') return;
    headerCart.dataset.bound = '1';
    headerCart.addEventListener('click', async (e) => {
      e.preventDefault();
      await refreshCart();
      openDrawer();
    });
  }
  bindHeaderCart();

  // Bei cart:refresh-Event → Refresh + Open
  document.addEventListener('cart:refresh', async () => {
    await refreshCart();
    openDrawer();
  });

  // Initial cart count refresh (für Header-Counter)
  refreshCart();
})();
